export enum ScheduledChannelSnapshotFrequency {
    DAILY = 1,
    WEEKLY = 2,
    MONTHLY = 3,
    MANUAL = 4,
}
